import React from 'react';
import { PropTypes as PT } from 'prop-types';
import ScheduleSearchResults from 'components/ScheduleModal/ScheduleSearch/ScheduleSearchResults';
import ScheduleSearchBar from 'components/ScheduleModal/ScheduleSearch/ScheduleSearchBar';
import DropdownComp from 'components/SearchDropdown/SearchDropdown';
import classes from './ScheduleSearch.module.scss';

export class ScheduleSearch extends React.PureComponent {
  render() {
    return (
      <div className={classes.scheduleSearchContainer}>
        <DropdownComp
          isVisible={this.props.isFocused}
          clickOutsideHandler={this.props.handleSetIsFocused}
          maxItems={this.props.maxItems}
          buttonComponent={<ScheduleSearchBar {...this.props} />}
          menuComponent={<ScheduleSearchResults {...this.props} />}
        />
      </div>
    );
  }
}

ScheduleSearch.propTypes = {
  isFocused: PT.bool,
  handleSetIsFocused: PT.func.isRequired,
  maxItems: PT.number.isRequired
};

export default ScheduleSearch;
